import React from "react";

const PageTitle = ({ desc, img }) => {
  return (
    <section
      className="page-title"
      style={{
        background: `url(${img}) no-repeat center center`,
        backgroundSize: "cover",
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "40vh",
      }}
    >
      <div className="overlay"></div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="block text-center">
              <span className="text-white">
                <a href="/">Home</a>
              </span>
              <h2
                style={{ fontWeight: "bold" }}
                className="text-white text-capitalize text-lg"
              >
                {desc}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageTitle;
